<template>
  <div>
    <div v-for="i in count" :key="i">
      <content-loader :width="400" :height="90" preserveAspectRatio="none">
        <rect x="0" y="20" rx="4" ry="4" width="90" height="60" />
        <rect x="110" y="30" rx="4" ry="4" width="200" height="20" />
        <rect x="110" y="60" rx="4" ry="4" width="200" height="10" />
      </content-loader>
    </div>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  name: "news-feed-loading-skeleton",
  props: {
    count: {
      type: Number,
      default: 7,
    },
  },
  components: { ContentLoader }
};
</script>

<style scoped>
</style>